import React, { useEffect, useState } from 'react';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import EditProductModal from './EditProducModal';
import { BASE_URL } from '../config';
// import function to delete product

const ITEMS_PER_PAGE = 50;

function SoldProductsList() {
    const [soldProducts, setSoldProducts] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [filters, setFilters] = useState({});
    const [filterConfigs, setFilterConfigs] = useState({});
    const [warehouses, setWarehouses] = useState([]);
    const [locations, setLocations] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [editProduct, setEditProduct] = useState(null);
    const [sortBy, setSortBy] = useState('none');
    const [sortDirection, setSortDirection] = useState('desc');
    const [sortFromDate, setSortFromDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

async function fetchData() {
    try {
        const [columnsResponse, soldProductsResponse, filterResponse, warehousesResponse, locationsResponse] = await Promise.all([
            fetch(`${BASE_URL}/api/columns`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            }),
            fetch(`${BASE_URL}/api/products/sold`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            }),
            fetch(`${BASE_URL}/api/filters`, { method: 'GET' }),
            fetch(`${BASE_URL}/api/warehouses`, { method: 'GET' }),
            fetch(`${BASE_URL}/api/locations`, { method: 'GET' })
        ]);

        // Parse responses to JSON
        const columnsData = await columnsResponse.json();
        const soldProductsData = await soldProductsResponse.json();
        const filterData = await filterResponse.json();
        const warehousesData = await warehousesResponse.json();
        const locationsData = await locationsResponse.json();

        setColumns(columnsData);
        // Set selected columns, excluding 'date' and 'is_sold' by default
        const columnsToShow = columnsData
            .filter(col => col.column_name !== 'date' && col.column_name !== 'sold_date' && col.column_name !== 'is_sold')
            .map(col => col.column_name);
        setSelectedColumns(columnsToShow);
        setSoldProducts(soldProductsData);
        setFilterConfigs(filterData);
        setWarehouses(warehousesData);
        setLocations(locationsData);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
}

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, filters, sortBy, sortDirection, sortFromDate]);

    const handleColumnChange = (selectedOptions) => {
        setSelectedColumns(selectedOptions.map(option => option.value));
    };

    const handleFilterChange = (column, values) => {
        setFilters({
            ...filters,
            [column]: values,
        });
    };
    const deleteProduct = async (id) => {
        //confirm delete
        const confirm = window.confirm('Czy na pewno chcesz usunąć ten produkt?');
        if (!confirm) return;
        const response = await fetch(`${BASE_URL}/api/delete/${id}`, {method: 'DELETE'});
        if (response.ok) {
            setSoldProducts(prev => prev.filter(product => product.id !== id));
        } else {
            alert('Error deleting product');
        }
    }
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const openEditModal = (product) => setEditProduct(product);

    const handleSaveChanges = async (updatedProduct) => {
        const response = await fetch(`${BASE_URL}/api/edit/${updatedProduct.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedProduct)
        });

        if (response.ok) {
            setEditProduct(null);
            fetchData();
        } else {
            alert('Error updating product');
        }
    };

    const revertSoldProduct = async (productId) => {
        const confirm = window.confirm('Czy na pewno cofnąć status sprzedanego produktu?');
        if (!confirm) return;

        try {
            const response = await fetch(`${BASE_URL}/api/mark-as-unsold/${productId}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                await fetchData();
            } else {
                alert('Błąd podczas cofania statusu sprzedanego produktu');
            }
        } catch (error) {
            console.error('Error reverting sold product:', error);
            alert('Wystąpił błąd podczas cofania statusu sprzedanego produktu');
        }
    };

    const filterSoldProducts = (product) => {
        // Najpierw standardowe filtry z selectów
        const matchesFilters = Object.keys(filters).every((column) => {
            if (!filters[column]?.length) return true;
            
            return filters[column].some((value) => {
                const productValue = product[column];
                
                // For size and other categorical fields, use exact matching
                if (column === 'size' || column === 'color' || column === 'brand' || column === 'warehouse' || column === 'location') {
                    if (typeof productValue === 'string') {
                        // Exact matching (case insensitive)
                        return productValue.toLowerCase() === value.toLowerCase();
                    }
                }
                
                // For other string fields, use includes matching as before
                if (typeof productValue === 'string') {
                    return productValue.toLowerCase().includes(value.toLowerCase());
                }
                if (typeof productValue === 'number') {
                    return productValue === parseFloat(value);
                }
                return false;
            });
        });

        // Wyszukiwanie w pozostałych polach
        const matchesSearch = Object.values(product).some(value =>
            value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );

        return matchesFilters && matchesSearch;
    };

    const renderFilterInput = (column) => {
        const filterConfig = filterConfigs[column.column_name];
        if (!filterConfig) return null;

        // Helper function to format size values more compactly
        const formatOptionLabel = (option, { context }) => {
            // If it's the size column, make the display more compact
            if (column.column_name === 'size') {
                return context === 'value' ? 
                    // For selected values in the input
                    <div style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>{option.label}</div> : 
                    // For options in the dropdown
                    <div className="size-filter-option">{option.label}</div>;
            }
            return option.label;
        };

        switch (filterConfig.type) {
            case "text":
            case "select":
                return (
                    <Select
                        isMulti
                        options={filterConfig.options.map(option => ({ value: option, label: option }))}
                        value={filters[column.column_name]?.map(value => ({ value, label: value })) || []}
                        onChange={selectedOptions => handleFilterChange(column.column_name, selectedOptions.map(option => option.value))}
                        className="react-select"
                        formatOptionLabel={column.column_name === 'size' ? formatOptionLabel : undefined}
                        placeholder={`Wybierz...`}
                        noOptionsMessage={() => "Brak opcji"}
                        isClearable={true}
                        isSearchable={true}
                        menuPortalTarget={document.body}
                        menuPosition={'fixed'}
                    />
                );
            case "number":
                return (
                    <input
                        type="number"
                        className="form-control form-control-sm mt-1"
                        value={filters[column.column_name] || ''}
                        onChange={e => handleFilterChange(column.column_name, e.target.value)}
                        placeholder={`Wprowadź ${column.column_display.toLowerCase()}...`}
                    />
                );
            case "magazyn":
                return (
                    <Select
                        isMulti
                        options={warehouses.map(warehouse => ({ value: warehouse.id, label: warehouse.name }))}
                        value={filters[column.column_name]?.map(value => ({
                            value,
                            label: warehouses.find(wh => wh.id === value)?.name
                        })) || []}
                        onChange={selectedOptions => handleFilterChange(column.column_name, selectedOptions.map(option => option.value))}
                        className="react-select"
                        placeholder="Wybierz magazyn..."
                        noOptionsMessage={() => "Brak magazynów"}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        menuPosition={'fixed'}
                    />
                );
            case "lokalizacja":
                return (
                    <Select
                        isMulti
                        options={locations.map(location => ({ value: location.location_id, label: location.name }))}
                        value={filters[column.column_name]?.map(value => ({
                            value,
                            label: locations.find(loc => loc.location_id === value)?.name
                        })) || []}
                        onChange={selectedOptions => handleFilterChange(column.column_name, selectedOptions.map(option => option.value))}
                        className="react-select"
                        placeholder="Wybierz lokalizację..."
                        noOptionsMessage={() => "Brak lokalizacji"}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        menuPosition={'fixed'}
                    />
                );
            default:
                return null;
        }
    };

    const visibleSoldProducts = soldProducts.filter(filterSoldProducts);

    const soldProductsAfterSelectedDate = sortBy === 'date' && sortFromDate
        ? visibleSoldProducts.filter((product) => {
            if (!product?.sold_date) return false;
            const productDate = new Date(product.sold_date);
            if (Number.isNaN(productDate.getTime())) return false;
            const selectedDate = new Date(`${sortFromDate}T00:00:00`);
            return productDate >= selectedDate;
        })
        : visibleSoldProducts;

    const sortedVisibleSoldProducts = [...soldProductsAfterSelectedDate].sort((a, b) => {
        const direction = sortDirection === 'asc' ? 1 : -1;

        if (sortBy === 'date') {
            const dateA = a?.sold_date ? new Date(a.sold_date).getTime() : 0;
            const dateB = b?.sold_date ? new Date(b.sold_date).getTime() : 0;
            return (dateA - dateB) * direction;
        }

        if (sortBy === 'name') {
            const nameA = (a?.name || '').toString();
            const nameB = (b?.name || '').toString();
            return nameA.localeCompare(nameB, 'pl', { sensitivity: 'base' }) * direction;
        }

        if (sortBy === 'sku') {
            const skuA = (a?.sku || '').toString();
            const skuB = (b?.sku || '').toString();
            return skuA.localeCompare(skuB, 'pl', { numeric: true, sensitivity: 'base' }) * direction;
        }

        if (sortBy === 'buy_price') {
            const priceA = parseFloat(a?.buy_price) || 0;
            const priceB = parseFloat(b?.buy_price) || 0;
            return (priceA - priceB) * direction;
        }

        if (sortBy === 'sale_price') {
            const priceA = parseFloat(a?.sale_price) || 0;
            const priceB = parseFloat(b?.sale_price) || 0;
            return (priceA - priceB) * direction;
        }

        return 0;
    });

    const totalPages = Math.max(1, Math.ceil(sortedVisibleSoldProducts.length / ITEMS_PER_PAGE));
    const paginatedProducts = sortedVisibleSoldProducts.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const formatDateTime = (value) => {
        if (!value) return '-';
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return value;
        return parsed.toLocaleString('pl-PL');
    };

    const getColumnClassName = (columnName) => {
        const classes = [];

        if (columnName === 'image') classes.push('image-column');
        if (columnName.includes('price')) classes.push('price-column');
        if (columnName === 'note') classes.push('note-column');
        if (columnName === 'sku') classes.push('sku-column');
        if (columnName === 'name') classes.push('name-column');
        if (['shop', 'order', 'ksfv', 'is_sold', 'size'].includes(columnName)) classes.push('compact-column');
        if (['date', 'sold_date'].includes(columnName)) classes.push('date-column');
        if (['location', 'warehouse'].includes(columnName)) classes.push('medium-text-column');
        if (['category'].includes(columnName)) classes.push('wide-text-column');

        return classes.join(' ');
    };

    const exportFilteredToCsv = () => {
        if (!sortedVisibleSoldProducts.length) {
            alert('Brak danych do eksportu CSV.');
            return;
        }

        const exportColumns = columns.filter(column => selectedColumns.includes(column.column_name));
        const headers = exportColumns.map(column => column.column_display);

        const formatCsvCell = (value, columnName) => {
            if (value === null || value === undefined) return '';

            if (columnName === 'is_sold') {
                return value ? 'Tak' : 'Nie';
            }

            if (columnName === 'date') {
                const parsed = new Date(value);
                if (!Number.isNaN(parsed.getTime())) {
                    return parsed.toLocaleString('pl-PL');
                }
            }

            return String(value);
        };

        const escapeCsv = (value) => `"${String(value).replace(/"/g, '""')}"`;

        const rows = sortedVisibleSoldProducts.map((product) =>
            exportColumns
                .map((column) => escapeCsv(formatCsvCell(product[column.column_name], column.column_name)))
                .join(';')
        );

        const csvContent = ['\uFEFF' + headers.map(escapeCsv).join(';'), ...rows].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const now = new Date();
        const pad = (num) => String(num).padStart(2, '0');
        const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;

        const link = document.createElement('a');
        link.href = url;
        link.download = `sprzedane_po_filtrach_${timestamp}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    };

    return (
        <Container fluid className="my-4">
            {/* SEKCJA: WYSZUKIWARKA + POLE WYBORU KOLUMN */}
            <Row className="mb-4 g-3 control-panel">
                {/* Wyszukiwarka */}
                <Col xs={12} md={4}>
                    <div className="search-wrapper position-relative">
                        <i className="bi bi-search position-absolute" style={{ left: '15px', top: '12px' }}></i>
                        <Form.Control
                            type="text"
                            placeholder="Szukaj..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            className="search-input"
                        />
                    </div>
                </Col>
                {/* Wybór kolumn do wyświetlenia */}
                <Col xs={12} md={5}>
                    <div className="d-flex align-items-center w-100">
                        <i className="bi bi-columns-gap me-2 text-primary"></i>
                        <Select
                            isMulti
                            placeholder="Wybierz kolumny..."
                            options={columns.map(column => ({
                                value: column.column_name,
                                label: column.column_display
                            }))}
                            value={columns
                                .filter(column => selectedColumns.includes(column.column_name))
                                .map(col => ({
                                    value: col.column_name,
                                    label: col.column_display
                                }))}
                            onChange={handleColumnChange}
                            className="react-select w-100"
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            menuPosition={'fixed'}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </div>
                </Col>

                {/* Sortowanie */}
                <Col xs={12} md={3}>
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex gap-2 align-items-center">
                            <i className="bi bi-sort-down text-primary"></i>
                            <Form.Select
                                value={sortBy}
                                onChange={(e) => {
                                    const nextSortBy = e.target.value;
                                    setSortBy(nextSortBy);
                                    if (nextSortBy !== 'date') {
                                        setSortFromDate('');
                                    }
                                }}
                                size="sm"
                                aria-label="Sortowanie według"
                            >
                                <option value="none">Bez filtrowania</option>
                                <option value="date">Data sprzedaży</option>
                                <option value="name">Nazwa produktu</option>
                                <option value="sku">Numer zamówienia (SKU)</option>
                                <option value="buy_price">Cena zakupu</option>
                                <option value="sale_price">Cena sprzedaży</option>
                            </Form.Select>

                            {sortBy !== 'none' && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'))}
                                    title={sortDirection === 'asc' ? 'Rosnąco' : 'Malejąco'}
                                >
                                    {sortDirection === 'asc' ? '↑' : '↓'}
                                </Button>
                            )}
                        </div>

                        {sortBy === 'date' && (
                            <div className="d-flex justify-content-end">
                                <Form.Control
                                    type="date"
                                    size="sm"
                                    value={sortFromDate}
                                    onChange={(e) => setSortFromDate(e.target.value)}
                                    aria-label="Pokaż sprzedane produkty od wybranej daty"
                                    style={{ maxWidth: '190px', borderRadius: '10px', fontSize: '0.85rem' }}
                                />
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="mb-2">
                <Col xs={12}>
                    <div className="small text-muted">
                        Sortowanie: <strong>{{
                            none: 'Bez filtrowania',
                            date: 'Data sprzedaży',
                            name: 'Nazwa produktu',
                            sku: 'Numer zamówienia (SKU)',
                            buy_price: 'Cena zakupu',
                            sale_price: 'Cena sprzedaży'
                        }[sortBy]}</strong>
                        {sortBy !== 'none' ? <> , kierunek: <strong>{sortDirection === 'asc' ? 'rosnąco' : 'malejąco'}</strong></> : null}
                        {sortFromDate ? <> , od daty sprzedaży: <strong>{sortFromDate}</strong></> : null}
                        , rekordów: <strong>{sortedVisibleSoldProducts.length}</strong>
                    </div>
                </Col>
            </Row>

            {/* Tabela */}
            <div className="table-responsive table-scroll-x">
                <Table striped hover bordered className="wide-table">
                    <thead>
                        <tr>
                            <th className="id-column text-center">#</th>
                            {columns.map((column) =>
                                selectedColumns.includes(column.column_name) && (
                                    <th key={column.column_name} className={getColumnClassName(column.column_name)}>
                                        <div className="d-flex flex-column position-relative">
                                            <span className="text-primary mb-1">{column.column_display}</span>
                                            {/* Pole do filtrowania w nagłówku */}
                                            {renderFilterInput(column)}
                                        </div>
                                    </th>
                                )
                            )}
                            <th className="actions-column text-center">
                                <div className="d-flex flex-column align-items-center gap-2">
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={exportFilteredToCsv}
                                        className="d-flex align-items-center"
                                    >
                                        EXPORT CSV
                                    </Button>
                                    <span>Wykonaj</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedProducts.map((product, index) => (
                            <tr key={product.id}>
                                <td className="id-column">{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                {columns.map((column) =>
                                    selectedColumns.includes(column.column_name) && (
                                        <td
                                            key={column.column_name}
                                            className={getColumnClassName(column.column_name)}
                                            style={{
                                                textAlign:
                                                    column.column_name === 'buy_price' || column.column_name === 'sale_price'
                                                        ? 'right'
                                                        : 'center'
                                            }}
                                        >
                                            {column.column_name === 'image' ? (
                                                <img
                                                src={`${BASE_URL}/static/media/${product[column.column_name]}`}
                                                alt="Product"
                                                loading="lazy"
                                                style={{
                                                  width: 'auto',
                                                  height: '100px',
                                                  display: 'block',
                                                  margin: '0 auto'
                                                }}
                                              />
                                            ) : column.column_name === 'is_sold' ? (
                                                product[column.column_name] ? 'Tak' : 'Nie'
                                            ) : column.column_name === 'date' || column.column_name === 'sold_date' ? (
                                                formatDateTime(product[column.column_name])
                                            ) : typeof product[column.column_name] === 'string' ? (
                                                <div className="truncate-text">
                                                    {product[column.column_name]}
                                                </div>
                                            ) : (
                                                product[column.column_name]
                                            )}
                                        </td>
                                    )
                                )}
                                <td className="actions-column">
                                    <div className="d-flex flex-column gap-1">
                                        <div className="d-flex gap-1">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() => openEditModal(product)}
                                                className="w-50 d-flex align-items-center justify-content-center"
                                            >
                                                <i className="bi bi-pencil-square me-1"></i> Edytuj
                                            </Button>
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                onClick={() => revertSoldProduct(product.id)}
                                                className="w-50 d-flex align-items-center justify-content-center"
                                            >
                                                <i className="bi bi-arrow-counterclockwise me-1"></i> Cofnij
                                            </Button>
                                        </div>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => deleteProduct(product.id)}
                                            className="w-100 d-flex align-items-center justify-content-center"
                                        >
                                            <i className="bi bi-trash me-1"></i> Usuń
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {totalPages > 1 && (
                <Row className="mt-3 justify-content-center align-items-center">
                    <Col xs="auto">
                        <div className="d-flex gap-2 align-items-center">
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setCurrentPage(1)}
                                disabled={currentPage === 1}
                            >
                                «
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                            >
                                ‹
                            </Button>
                            <span className="small text-muted px-2">
                                Strona <strong>{currentPage}</strong> / <strong>{totalPages}</strong>
                                {' '}({sortedVisibleSoldProducts.length} rekordów)
                            </span>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                            >
                                ›
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={currentPage === totalPages}
                            >
                                »
                            </Button>
                        </div>
                    </Col>
                </Row>
            )}

            {editProduct && (
                <EditProductModal
                    show={Boolean(editProduct)}
                    product={editProduct}
                    onHide={() => setEditProduct(null)}
                    onSave={handleSaveChanges}
                />
            )}
        </Container>
    );
}

export default SoldProductsList;